import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.getSelect(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}
export const serviceGetImplicados = async(query) => {
    try {
        const response = await client.getImplicado(`caso/implicado/terceros?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceGetInforme = async(query) => {
    try {
        const response = await client.getDoc(`get-file?q=${query}`);      

        if (response.status === 200 && response.data.code === 1) return response.data
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}
export const serviceGetDatosImplicado = async(query) => {
    try {
        const response = await client.getSelect(`caso/implicado?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } catch(error){
        throw error;
    }
}
export const getAntecedentesCaso = async(query) => {
    try {
        
        const response = await client.get(`caso?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}